import script from "./productGroupsNavLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./productGroupsNavLinks.vue?vue&type=script&setup=true&lang=ts"

import "./productGroupsNavLinks.vue?vue&type=style&index=0&id=38099430&lang=scss&scope=true"

const __exports__ = script;

export default __exports__